module.exports = __webpack_public_path__ + "78853738efd8ce9a2444043d3723101e.jpg";